import { render, staticRenderFns } from "./SalesApprovalUpload.vue?vue&type=template&id=dcf04e90&scoped=true"
import script from "./SalesApprovalUpload.vue?vue&type=script&lang=js"
export * from "./SalesApprovalUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf04e90",
  null
  
)

export default component.exports